<!--
 * @description: 结存数报表
 * @author: ckj
 * @date: 2024/9/21 9:28
-->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form ref="searchForm" @search="onSearch" @reset="resetQuery" :formList="formList">
        <global-select
          slot="purchaseType"
          :dropdown-match-select-width="false"
          :value.sync="queryParams.purchaseType"
          selectType="select"
          requestApi="/system/lookup/data/list"
          :selectItem="{ value: 'lookupCode', label: 'lookupValue' }"
          :setParams="{ lookupType: 'ATTR03' }"
          searchParam="lookupValue"
        />
        <global-select
          v-decorator="['factoryCode', { rules: [{ required: true }] }]"
          slot="factoryCode"
          :value.sync="queryParams.factoryCode"
          :dropdown-match-select-width="false"
          :selectData="inventOrg"
          :selectItem="{ value: 'realValue', label: 'label' }"
          :allow-clear="false"
          :default-active-first-option="true"
        />
        <ls-select-page
          slot="snapshotBatch"
          v-decorator="['snapshotBatch',]"
          placeholder="请选择"
          :datas="snapshotBatchsList">
            <template slot="select-option" slot-scope="{ items }">
              <a-select-option
                  v-for="item in items"
                  :key="item"
              >{{ item }}</a-select-option>
            </template>
      </ls-select-page>
      </ls-search-form>
    </div>
    <div slot="btn">
      <a-space>
        <download-modal :apiFun="apiWmsStockSnapshotDetailExport" ref="download" />
        <a-button type="primary" @click="handleExport" v-hasPermi="['inv:invOnhandQuantities:wmsStockSnapshotDetailExpo']">导出</a-button>
      </a-space>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1000 }"
        >
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { mapState } from 'vuex'
import { apiGetWmsStockSnapshotDetailList, apiWmsStockSnapshotDetailExport, apiGetSnapshotBatchs } from '@/api/report/balance-report.js'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  // eslint-disable-next-line
  name: 'Balance-report', // name要和rms配置菜单路由保存一致(首字母大写)
  components: { DownloadModal },
  computed: {
    ...mapState({
      inventOrg: (state) => state.user.inventOrg,
      organizationCodeOrigin: (state) => state.user.organizationCode
    })
  },
  data () {
    return {
      apiWmsStockSnapshotDetailExport,
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiGetWmsStockSnapshotDetailList, true),
        pageCurrent: true
      },
      // 控制搜索展开
      advanced: true,
      snapshotBatchsList: [],
      snapshotBatchsInit: null,
      // 查询参数
      queryParams: {
        factoryCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        purchaseType: '0',
        colorDifferFlag: undefined,
        lotName: undefined,
        snapshotBatch: undefined
      },
      // 表格数据
      tableList: [],
      formList: [
        {
          label: '组织',
          decorator: ['factoryCode'],
          type: 'factoryCode'
        },
        {
          label: '子库编码',
          decorator: ['tenantId'],
          type: 'input'
        },
        {
          label: '物料编码',
          decorator: ['skuKey'],
          type: 'input'
        },
        {
          label: '物料名称',
          decorator: ['skuName'],
          type: 'input'
        },
        {
          label: '采购类型',
          decorator: ['purchaseType'],
          type: 'purchaseType'
        },
        {
          label: '库存层级',
          decorator: ['colorDifferFlag'],
          type: 'input'
        },
        {
          label: '生产批次',
          decorator: ['lotName'],
          type: 'input'
        },
        {
          label: '数据快照时间',
          type: 'snapshotBatch',
          decorator: ['snapshotBatch']
        }
      ],
      // 表格字段
      columns: [
        {
          title: '数据快照时间',
          dataIndex: 'snapshotBatch',
          align: 'center',
          width: 120,
          ellipsis: true
        }, {
          title: '子库编码',
          dataIndex: 'tenantId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库',
          dataIndex: 'invlocationName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '库位',
          dataIndex: 'lockey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料编码',
          dataIndex: 'skuKey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '物料名称',
          dataIndex: 'skuName',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '规格描述',
          dataIndex: 'specModel',
          align: 'center',
          width: 200,
          ellipsis: true
        },
        {
          title: '单位',
          dataIndex: 'unit',
          align: 'center',
          width: 100,
          ellipsis: true
        },
        {
          title: '批次',
          dataIndex: 'lotkey',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '现有量',
          dataIndex: 'onhandQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '可用量',
          dataIndex: 'availableQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '分配量',
          dataIndex: 'assignedQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '拣货量',
          dataIndex: 'pickQty',
          align: 'center',
          width: 120,
          ellipsis: true
        },
        {
          title: '状态',
          dataIndex: 'status',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '组织代码',
          dataIndex: 'orgNo',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '子库代码',
          dataIndex: 'zzCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '采购类型',
          dataIndex: 'purchaseName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '入库日期',
          dataIndex: 'deliveryDate',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '供应商代码',
          dataIndex: 'supplierCode',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '工单号',
          dataIndex: 'wipEntityName',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '计划单号',
          dataIndex: 'planNo',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '色差标志/库存层级',
          dataIndex: 'colorDifferFlag',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '生产批次号',
          dataIndex: 'lotName',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '分包序号',
          dataIndex: 'subpackageSn',
          align: 'center',
          width: 180,
          ellipsis: true
        },
        {
          title: '源子库',
          dataIndex: 'sourceTenantId',
          align: 'center',
          width: 150,
          ellipsis: true
        },
        {
          title: '数据创建时间',
          dataIndex: 'createTime',
          align: 'center',
          width: 150,
          ellipsis: true
        }
      ]
    }
  },
  created () {
    this.getSnapshotBatchs()
  },
  methods: {
    // 表单搜索
    onSearch (value = {}) {
      const params = {
       ...this.queryParams,
       ...value
      }
      delete params.searchFormLabel
      if (params.purchaseType.toString() === '0') {
        delete params.purchaseType
      }
      this.$refs.dataTable.searchParams = params;
      this.$refs.dataTable.getData();
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        factoryCode: undefined,
        tenantId: undefined,
        skuKey: undefined,
        skuName: undefined,
        purchaseType: '0',
        colorDifferFlag: undefined,
        lotName: undefined,
        snapshotBatch: undefined
      }
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    // 导出
    handleExport () {
      const params = this.$refs.dataTable.searchParams
      this.$refs.download.openModal(params)
      // this.download('inv/invOnhandQuantities/wmsStockQtyExport', this.$refs.dataTable.searchParams, `库存余额_${new Date().getTime()}.xlsx`)
    },
    getSnapshotBatchs() {
      apiGetSnapshotBatchs().then((res) => {
        if(res.code === 200) {
          this.snapshotBatchsList = res.data
         const arr = this.snapshotBatchsList.map(item => Number(item))
         this.snapshotBatchsInit = Math.max.apply(null, arr)
          if (!this.queryParams?.snapshotBatch) {
            this.$refs.searchForm.form.setFieldsValue({ snapshotBatch: this.snapshotBatchsInit })
          }
         this.$refs.searchForm.handleSearch()
        }
      })
    }
  }
}
</script>

<style scoped lang="less"></style>
